/**
 * QuoteDuplicateDialog — Phase 2C.M+ (2026-09-07, refacto ClientPicker).
 *
 * Dialog "Dupliquer le devis" — délègue toute la sélection contact/projet au
 * composant partagé `ClientPicker`. Le backend recalcule la TVA par ligne
 * (catalog → company default) et refuse tout fallback `21` en dur.
 */
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import ClientPicker from "@/components/quote/ClientPicker";

export default function QuoteDuplicateDialog({ open, onOpenChange, quote, onSuccess }) {
  const handleSelect = async (targetLeadId) => {
    try {
      const { data } = await api.post(`/quotes/${quote.id}/duplicate`, {
        target_lead_id: targetLeadId,
      });
      toast.success("Devis dupliqué en brouillon");
      onSuccess?.(data.id);
    } catch (e) {
      toast.error(formatApiError(e));
      throw e;
    }
  };

  return (
    <ClientPicker
      open={open}
      onOpenChange={onOpenChange}
      title="Dupliquer le devis"
      description="Choisissez le contact et le projet cible. Le duplicata repart en brouillon sans numéro. La TVA de chaque ligne est recalculée depuis votre catalogue / paramètres société (jamais recopiée du devis source)."
      confirmLabel="Dupliquer"
      submittingText="Duplication…"
      sourceLeadId={quote?.lead_id || null}
      onSelect={handleSelect}
    />
  );
}
